module.exports = __webpack_public_path__ + "img/canvasMenu1.c49111d7.svg";